import { useMemo } from 'react'
import { getGeneralFieldsConfig } from '../../../api/contacts/formValuesConfig'
import contacts from '../../../api/contacts/hooks'
import { ContactType } from '../../../api/globalTypes'
import properties from '../../../api/properties/hooks'
import agents from '../../../api/agents/hooks'
import { formatAgentOptions } from '../../../api/agents/formatters'
import { contactGeneralFields } from '../../../common/forms/contacts/fields'
import { mapValuesToFormFields } from '../../../utils/formUtils/forms'

export const useContactGeneralFormSelectOptions = (contactType: ContactType = ContactType.Person) => {
    const fieldsConfig = useMemo(
        () => getGeneralFieldsConfig(contactType === ContactType.Person ? ContactType.Person : ContactType.Company),
        [contactType]
    )

    const personFormFields = ['title', 'priority', 'source', 'status', 'phoneType', 'emailType', 'country', 'queryCategory']
    const companyFormFields = ['legalForm', 'priority', 'source', 'status', 'phoneType', 'emailType', 'country', 'queryCategory']

    const contactFormFields = contactType === ContactType.Person ? personFormFields : companyFormFields

    const { data: contactValues, isPending: isPendingContactValues } = contacts.FormValues.useQuery(contactFormFields)
    const { data: propertyValues, isPending: isPendingPropertyValues } = properties.FormValues.useQuery(['dataSource'])
    const { data: agentsData, isPending: isAgentsPending } = agents.GetAgents.useQuery()

    const contactSelectOptions = useMemo(() => {
        return mapValuesToFormFields(contactValues, fieldsConfig)
    }, [contactValues, fieldsConfig])

    const selectOptions = useMemo(
        () => ({
            ...contactSelectOptions,
            [contactGeneralFields.DATA_SOURCE_ID]: propertyValues?.dataSource,
            [contactGeneralFields.AGENT_ID]: formatAgentOptions(agentsData),
        }),
        [contactSelectOptions, propertyValues?.dataSource, agentsData]
    )

    return { selectOptions, isPending: isPendingContactValues || isPendingPropertyValues || isAgentsPending }
}
